import type {RouterHistory} from 'src/rerouter';
import {routePageCollector} from './route';
import {askAISourceCollector} from './askai-source';
import {askAIExtraPageContextCollector} from './askai-extra-page-context';


export type PreSendCollectorContext = {
  readonly history: RouterHistory;
};

export type PreSendCollectorResult = Record<string, unknown> | void;

export type PreSendCollector = {
  id: string;
  when?: (ctx: PreSendCollectorContext) => boolean | Promise<boolean>;
  collect: (ctx: PreSendCollectorContext) => Promise<PreSendCollectorResult>;
};

/**
 * NOTE:(diwaker) add more collectors here as needed
 */
const defaultCollectors: PreSendCollector[] = [
  askAISourceCollector,
  routePageCollector,
  // Keep this last so programmatic overrides win over route/query keys
  askAIExtraPageContextCollector,
];

export async function runPreSendCollectors(
  ctx: PreSendCollectorContext,
  extraCollectors?: PreSendCollector[],
): Promise<Record<string, unknown>> {
  const list = [...defaultCollectors, ...(extraCollectors ?? [])];
  const outputs: Record<string, unknown>[] = [];
  for (const c of list) {
    try {
      const use = (await (c.when ? c.when(ctx) : true)) as boolean;
      if (!use) {
        continue;
      }
      const res = await c.collect(ctx);
      if (res) {
        outputs.push(res as Record<string, unknown>);
      }
    } catch {
      // swallow collector errors; non-fatal
    }
  }
  const merged: Record<string, unknown> = {};
  for (const r of outputs) {
    Object.assign(merged, r);
  }
  return merged;
}
